var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.68 15.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.34,2.62L8.81,15.12c-.53,.7-1.49,.81-2.17,.25L.59,10.32c-.67-.56-.79-1.57-.26-2.27,.53-.7,1.49-.81,2.17-.25l4.86,4.03L15.94,.6c.53-.7,1.49-.81,2.17-.25,.65,.56,.77,1.57,.24,2.27h0Z",
    fill: "#75e8f0",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick2);
export default __webpack_public_path__ + "static/media/tick-2.7932a1b0f8981977d87a911876bd8404.svg";
export { ForwardRef as ReactComponent };